// Domain config + view-model types shared across the master-data import flow.
// All runtime data now comes from the imports API (see `importsApi.ts`); this
// file holds only the static entity metadata and the committed-summary shape.

import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"

export type EntityGroupType =
  | "suppliers"
  | "articles"
  | "substances"
  | "products"
  | "customers"

export interface EntityGroup {
  type: EntityGroupType
  count: number
  confidence: number
  status: "ok" | "warn" | "missing"
  /** Reconstructed sample rows for the review preview, keyed by target field. */
  samples?: Record<string, unknown>[]
}

export interface CommittedSummary {
  groups: EntityGroup[]
  total: number
  ts: string
  files: string[]
  overrideCount: number
  noteCount: number
}

// `labelKey` points at the localized MC_MD_TAB_* key (plural label); all
// consumers render it through translate() — see EntityScoreboard,
// MasterDataCommitSummary, `mappingUtils.formatAssignmentLabel` and
// `MasterDataImportModule`'s import-history tooltip.
export const ENTITY_META: Record<
  EntityGroupType,
  { labelKey: TranslationKeys }
> = {
  suppliers: {
    labelKey: "MC_MD_TAB_SUPPLIERS",
  },
  articles: {
    labelKey: "MC_MD_TAB_ARTICLES",
  },
  substances: {
    labelKey: "MC_MD_TAB_SUBSTANCES",
  },
  products: {
    labelKey: "MC_MD_TAB_PRODUCTS",
  },
  customers: {
    labelKey: "MC_MD_TAB_CUSTOMERS",
  },
}
